export const DEFAULT_COLUMN_WIDTH = 180;
export const MIN_COLUMN_WIDTH = 40;
export const MAX_COLUMN_WIDTH = 1000;
